import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class HandTool extends BaseTool {
  public id: ToolType = 'hand';
  public name = 'Hand / Pan Tool';
  public cursor = 'grab';

  private isPanning = false;
  private startScreenX = 0;
  private startScreenY = 0;
  private startPanX = 0;
  private startPanY = 0;

  public onMouseDown(e: MouseEvent): void {
    this.isPanning = true;
    this.cursor = 'grabbing';
    this.startScreenX = e.clientX;
    this.startScreenY = e.clientY;
    this.startPanX = this.editor.panX;
    this.startPanY = this.editor.panY;
    this.editor.updateCursor();
  }

  public onMouseMove(e: MouseEvent): void {
    if (!this.isPanning) return;
    const dx = e.clientX - this.startScreenX;
    const dy = e.clientY - this.startScreenY;
    this.editor.panX = this.startPanX + dx;
    this.editor.panY = this.startPanY + dy;
    this.editor.render();
  }

  public onMouseUp(_e: MouseEvent): void {
    if (this.isPanning) {
      this.isPanning = false;
      this.cursor = 'grab';
      this.editor.updateCursor();
    }
  }
}
